import gql from 'graphql-tag';

export default gql`
	mutation deleteSurveys($surveyIds: [ID!], $removeAll: Boolean, $memberId: ID) {
		deleteSurveys(surveyIds: $surveyIds, removeAll: $removeAll, memberId: $memberId) {
			success
		}
	}
`;
